import { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useFormik } from "formik";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import { useHistory, useParams } from "react-router-dom";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Loader from "../../Components/Common/Loader";
import { usePublicity, usePublishPublicity } from "../../hooks/usePublicities";
import defaultPublicityImage from "../../assets/images/lcbtp.png";
SwiperCore.use([FreeMode, Navigation, Thumbs]);

function PublicitiesValidation(props) {
  const history = useHistory();
  const { id } = useParams();

  const { data: selectAticle, isLoading, isError, error } = usePublicity(id);

  const publishMutation = usePublishPublicity();

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      published: false,
    },

    validationSchema: Yup.object({
      published: Yup.boolean(),
    }),

    onSubmit: (values) => {
      publishMutation.mutate(
        { id },
        {
          onSuccess: () => {
            history.push("/advertisements");
            validation.resetForm();
          },
        }
      );
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <Loader error={error?.message || props.t("Erreur lors du chargement")} />
    );
  }

  document.title = props.t("Validation d'une publicité");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Validation d'une publicité")}
          pageTitle={props.t("Publicité")}
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={12}>
                    <div className="mt-xl-0 mt-5">
                      <img
                        src={
                          selectAticle.publicity_pic || defaultPublicityImage
                        }
                        alt={props.t("Image de la publicité")}
                        className="rounded"
                        style={{ height: "30%", width: "100%" }}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = defaultPublicityImage;
                        }}
                      />
                      <div className="d-flex">
                        <div className="flex-wrap flex-1 gap-3">
                          <br></br>
                          <h2> {selectAticle.title}</h2>
                        </div>
                      </div>
                      <div
                        className="mt-4 text-muted"
                        style={{ textAlign: "justify" }}
                      >
                        <p>{selectAticle.publicity_content}</p>
                      </div>

                      <div className="product-content mt-5">
                        <Nav tabs className="nav-tabs-custom nav-success">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              {props.t("Détails")}
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                          activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane id="nav-speci" tabId="1">
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row">
                                      {" "}
                                      {props.t("Date de création")}
                                    </th>
                                    <td
                                      className="text-blue-500"
                                      style={{ color: "blue" }}
                                    >
                                      {selectAticle.created_at}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row"> {props.t("Auteur")} </th>
                                    <td
                                      className="text-red-500"
                                      style={{ color: "red" }}
                                    >
                                      {selectAticle.user &&
                                        selectAticle.user.username}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Form
                  encType="multipart/form-data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <br></br>
                  <input
                    type="checkbox"
                    name="published"
                    className="form"
                    style={{
                      fontWeight: "30px",
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                    checked={validation.values.published}
                    onChange={validation.handleChange}
                  />
                  <b>
                    {" "}
                    J'ai vérifié cette publicité et je confirme son authenticité{" "}
                  </b>
                  <div className="text-end mb-3">
                    <Link to="/advertisements" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                    <button
                      type="submit"
                      className="btn btn-warning"
                      disabled={publishMutation.isPending}
                    >
                      {publishMutation.isPending && (
                        <Spinner size="sm" className="me-2" />
                      )}
                      {props.t("Valider la publicité")}
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

PublicitiesValidation.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(PublicitiesValidation));
